import store from './store'
import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login'
import King from './views/King'
import Layout from './components/layout/appMain'
import LayoutLogin from './components/layout/layoutLogin'
import GP from './views/GP'
import LOL from './views/LOL'
import BS from './views/BS'
import Msg from './views/Msg'
import Set from './views/Set'
import leftMain from './components/layout/leftMain'
import GI from './views/GI'
import TY from './views/TY'
import Codm from './views/Codm'
import PriceHome from './views/PriceHome'
import Mlol from './views/MLOL'
import JCC from './views/JCC'
import MGFLOL from './views/MGFLOL'
import WyRace from './views/WyRace'
Vue.use(Router)


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'layoutLogin',
      component: LayoutLogin,
      redirect: '/login',
      children: [
        {
          path: '/login',
          name: 'login',
          component: Login,
          hidden: true
        }
      ]
    },
    {
      path: '/main',
      name: 'main',
      component: Layout,
      children: [
        {
          path: 'price',
          name: 'price',
          component: leftMain,
          children: [
            {
              name: 'priceHome',
              path: 'priceHome',
              component: PriceHome,
              redirect: to => {
                // 方法接收 目标路由 作为参数
                // return 重定向的 字符串路径/路径对象
                let path = localStorage.getItem('DEFAULT_PRICE_URL')
                if (path == '') {
                  path = '/main/price/king'
                }
                return path
              }
            },
            {
              path: 'lol',
              name: 'lol',
              component: LOL,
              hidden: true
            },
            {
              path: 'king',
              name: 'king',
              component: King,
              hidden: true,
            },
            {
              path: 'gp',
              name: 'gp',
              component: GP,
              hidden: true
            },
            {
              path: 'bs',
              name: 'bs',
              component: BS,
              hidden: true
            },
            {
              path: 'gi',
              name: 'gi',
              component: GI,
              hidden: true
            },
            {
              path: 'ty',
              name: 'ty',
              component: TY,
              hidden: true
            },
            {
              path: 'codm',
              name: 'codm',
              component: Codm,
              hidden: true
            },
            {
              path: 'mlol',
              name: 'mlol',
              component: Mlol,
              hidden: true
            },
            {
              path: 'jcc',
              name: 'jcc',
              component: JCC,
              hidden: true
            },
            {
              path: 'mGFLOL',
              name: 'mGFLOL',
              component: MGFLOL,
              hidden: true
            },
            {
              path: 'wyRace',
              name: 'wyRace',
              component: WyRace,
              hidden: true
            }
          ],
        },
        {
          path: 'msg',
          name: 'msg',
          component: Msg,
          hidden: true
        },
        {
          path: 'set',
          name: 'set',
          component: Set,
          hidden: true
        }
      ],
    }
  ]
})

/**
 * 重写路由的push方法
 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
